import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2C2C2C] text-white">
      <div className="rounded-t-3xl overflow-hidden">
        <div className="px-4 md:px-8 py-12 md:py-16">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            {/* Newsletter */}
            <div className="md:col-span-1">
              <h3 className="text-xl font-semibold mb-4">LUCIALLからのお知らせ</h3>
              <p className="text-light-gray text-sm mb-4 leading-relaxed">
                最新のキャンペーン情報や美容情報をお届けします
              </p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="メールアドレス"
                  className="flex-1 px-4 py-2 rounded-lg bg-white/10 text-white placeholder-light-gray border border-white/20 focus:outline-none focus:border-gold"
                />
                <button className="bg-gold text-white px-6 py-2 rounded-full hover:bg-gold/90 transition-colors whitespace-nowrap">
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>

            {/* Menu Links */}
            <div>
              <h3 className="text-base font-bold mb-4">メニュー</h3>
              <ul className="space-y-3">
                <li><Link to="/menu" className="text-sm text-white hover:text-gold transition-colors">メニュー・料金</Link></li>
                <li><Link to="/machines" className="text-sm text-white hover:text-gold transition-colors">マシン紹介</Link></li>
                <li><Link to="/shop" className="text-sm text-white hover:text-gold transition-colors">オンラインショップ</Link></li>
                <li><Link to="/first-time" className="text-sm text-white hover:text-gold transition-colors">初めての方へ</Link></li>
                <li><Link to="/about" className="text-sm text-white hover:text-gold transition-colors">オーナー紹介</Link></li>
                <li><Link to="/blog" className="text-sm text-white hover:text-gold transition-colors">ブログ</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-base font-bold mb-4">お問い合わせ</h3>
              <div className="space-y-3">
                <a href="tel:08091541191" className="flex items-center gap-2 text-xl font-semibold hover:text-gold transition-colors">
                  <i className="ri-phone-fill w-5 h-5 flex items-center justify-center"></i>
                  <span>080-9154-1191</span>
                </a>
                <p className="flex items-start gap-2 text-sm text-light-gray">
                  <i className="ri-map-pin-fill w-5 h-5 flex items-center justify-center mt-0.5"></i>
                  <span>奈良県香芝市瓦口158-4<br />エー・アイビル202号室</span>
                </p>
                <p className="flex items-center gap-2 text-sm text-light-gray">
                  <i className="ri-time-fill w-5 h-5 flex items-center justify-center"></i>
                  <span>10:00〜19:00（定休日：不定休）</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="bg-[#1A1A1A] px-4 md:px-8 py-6">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <a href="https://instagram.com/luciall" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white rounded-full text-gold hover:bg-gold hover:text-white transition-colors">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="https://facebook.com/luciall" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white rounded-full text-gold hover:bg-gold hover:text-white transition-colors">
                <i className="ri-facebook-fill"></i>
              </a>
              <a href="https://line.me/R/ti/p/@luciall" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-white rounded-full text-gold hover:bg-gold hover:text-white transition-colors">
                <i className="ri-line-fill"></i>
              </a>
            </div>

            <p className="text-xs text-light-gray text-center">
              © {currentYear} LUCIALL. All rights reserved.
            </p>

            <div className="flex items-center gap-3 text-xs text-light-gray">
              <Link to="/privacy" className="hover:text-white transition-colors">プライバシーポリシー</Link>
              <span>|</span>
              <Link to="/legal" className="hover:text-white transition-colors">特定商取引法</Link>
              <span>|</span>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
